import React, { useEffect } from 'react';
import {
    Palette,
    Navigation,
    LayoutDashboard,
    Image,
    Star,
    Quote,
} from 'lucide-react';
import usePersistedTab from '../hooks/usePersistedTab';
import ThemeSettings      from '../components/Storefront/ThemeSettings';
import NavigationSettings from '../components/Storefront/NavigationSettings';
import HomepageBuilder    from '../components/Storefront/HomepageBuilder';
import BannersSettings    from '../components/Storefront/BannersSettings';
import ReviewsSettings    from '../components/Storefront/ReviewsSettings';
import TestimonialsSettings from '../components/Storefront/TestimonialsSettings';
import {tabClass, tabIconClass} from '../components/Common/TabBar';

const TABS = [
    { key: 'theme',          label: 'Thème',          Icon: Palette },
    { key: 'navigation',     label: 'Navigation',     Icon: Navigation },
    { key: 'homepage',       label: "Page d'accueil", Icon: LayoutDashboard },
    { key: 'banners',        label: 'Bannières',      Icon: Image },
    { key: 'reviews',        label: 'Avis',           Icon: Star },
    { key: 'testimonials',   label: 'Témoignages',    Icon: Quote },
];

const StorefrontPage = () => {
    const [activeTab, setActiveTab] = usePersistedTab('tab_storefront', 'theme');

    useEffect(() => {
        document.title = 'Boutique en ligne - Dashboard';
    }, []);

    return (
        <>
            {/* Page title */}
            <h1 className="text-xl sm:text-2xl font-medium text-center mb-4 sm:mb-6 mt-4 sm:mt-6">
                Boutique en ligne
            </h1>

            {/* Tab bar */}
            <div className="border-b border-gray-200 dark:border-gray-700">
                <div className="flex overflow-x-auto no-scrollbar md:justify-center">
                    {TABS.map(({ key, label, Icon }) => (
                        <button
                            key={key}
                            onClick={() => setActiveTab(key)}
                            className={tabClass(activeTab === key)}
                        >
                            <Icon className={tabIconClass} />
                            {label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tab content */}
            <div className="pt-4 pb-12">
                {activeTab === 'theme'        && <ThemeSettings />}
                {activeTab === 'navigation'   && <NavigationSettings />}
                {activeTab === 'homepage'     && <HomepageBuilder />}
                {activeTab === 'banners'      && <BannersSettings />}
                {activeTab === 'reviews'      && <ReviewsSettings />}
                {activeTab === 'testimonials' && <TestimonialsSettings />}
            </div>
        </>
    );
};

export default StorefrontPage;
